import {
  NegativeColors,
  PositiveColors,
  PrimaryColors,
} from '@picsart/design-system/foundation/colors';
import { FontSizes, LineHeights } from '@picsart/design-system/foundation/typography';

import { createUseStyles } from 'react-jss';
// import { BreakPoints } from '@picsart/rc/enums';

import { DEFAULT_COLOR_SCHEME } from 'redesignedComponents/context/colorScheme';

import { Easing } from '@picsart/design-system/foundation/easing';
import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { Timings } from '@picsart/design-system/foundation/timings';
import type { ColorSchemeType } from 'redesignedComponents/context/colorScheme/types';

type StyleProps = {
  colorScheme: ColorSchemeType;
};

const useStyles = createUseStyles<string, StyleProps>(
  () => ({
    root: props => ({
      padding: [Spacings.s64, Spacings.s0],
      backgroundColor:
        props?.colorScheme === DEFAULT_COLOR_SCHEME
          ? PositiveColors.base.default
          : NegativeColors.base.default,
      color:
        props?.colorScheme === DEFAULT_COLOR_SCHEME
          ? PositiveColors.text.default
          : NegativeColors.text.default,
      // [mediaQuery(BreakPoints.Small)]: {
      '@media screen and (max-width: 766px)': {
        padding: [Spacings.s40, Spacings.s0],
      },
    }),
    title: {
      display: '-webkit-box',
      lineClamp: 2,
      boxOrient: 'vertical',
      maxWidth: 954,
      margin: [Spacings.s0, 'auto', Spacings.s16],
      fontSize: FontSizes.s60,
      fontWeight: FontWeights.semibold,
      textAlign: 'center',

      // [mediaQuery(BreakPoints.Small)]: {
      '@media screen and (max-width: 768px)': {
        lineClamp: 4,
        maxWidth: 456,
      },

      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        margin: [Spacings.s0, 'auto', Spacings.s6],
        lineClamp: 5,
        fontSize: FontSizes.s36,
      },
    },
    link: {
      outline: 'none',
      marginBottom: Spacings.s12,
      '&:hover': {
        color: PrimaryColors.base.default,
        transition: `color ${Timings.default} ${Easing.easeInOut}`,
      },
    },
    description: {
      maxWidth: 730,
      width: '100%',
      fontSize: FontSizes.s20,
      margin: [0, 'auto'],
      textAlign: 'center',
      padding: [0, 0, Spacings.s48],
      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        fontSize: FontSizes.s16,
      },
    },

    templateLink: props => ({
      display: 'flex',
      justifyContent: 'flex-end',
      '& > button': {
        border: 0,
        background: 'none',
        marginRight: Spacings.s8,
        fontWeight: FontWeights.medium,
        fontSize: FontSizes.s20,
        lineHeight: LineHeights.l24,
        // TODO replace with variable when provided
        color: props?.colorScheme === DEFAULT_COLOR_SCHEME ? PrimaryColors.base.active : '#E859B4',

        // [mediaQuery(767)]: {
        '@media screen and (max-width: 767px)': {
          fontSize: FontSizes.s16,
        },
        '&:hover': {
          cursor: 'pointer',
          color: props?.colorScheme === DEFAULT_COLOR_SCHEME && PrimaryColors.base.action,
        },
      },
    }),

    grid: {
      gap: Spacings.s24,
      marginTop: Spacings.s24,
      columns: '150px 5',
      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        marginTop: Spacings.s16,
      },
      // // [mediaQuery(766)]: {
      // '@media screen and (max-width: 766px)': {
      //   gridTemplateColumns: 'repeat(2, 1fr)',
      // },
    },
    footerButton: {
      '&&': {
        display: 'flex',
        width: 'fit-content',
        margin: [Spacings.s24, 'auto', 0],
      },
    },
    // Skeleton
    skeletonTitle: {
      extend: 'title',
      maxWidth: 500,
      height: 48,
    },
    skeletonGrid: {
      extend: 'grid',
      '& > i': {
        maxWidth: 304,
        height: 200,
      },
    },
  }),
  {
    name: 'templates',
  },
);

export default useStyles;
